import React from "react";
import { Button , withStyles} from "@material-ui/core";
import appConstant from "../../appConstants";

// Using hardcoded colors since this page should be independent of the theme
const styles = {
    pageBg: {
        background:'url(../images/404bgLight.png)',
        width:"100%",
        height:"100%",
        display:"flex",
        justifyContent:"space-around",
        boxSizing:"border-box",
        backgroundSize:"cover",
        backgroundRepeat:"no-repeat",
        '& > *':{
            boxSizing:"border-box",
        }
    },
    container:{
        minWidth:320,
        width:"50%",
        display: "flex",
        flexDirection:"column",
        justifyContent:"space-evenly",
        padding:"0px 8px",
        '@media (max-width: 1024px)': {
            width:"80%",
        }
    },
    pageIconContainer:{
        marginTop:"15%",
        padding:"5% 0px",
        height:"45%",
        display:"flex",
        justifyContent:"space-around"
    },
    pageIcon:{
        width:"40%",
        minWidth: 200,
        background:'url(../images/404IconLight.png)',
        backgroundSize:"contain",
        backgroundRepeat:"no-repeat",
        '&:after':{
            content:"",
            display: "block",
            paddingBottom:"100%"
        }
    },
    messageTitle:{
        height: 72,
        lineHeight: "47px",
        fontSize: 35,
        color: "#077566",
        fontWeight: "bold",
        textAlign: "center",
        '@media (max-width: 480px)': {
            fontSize: 20,
        }
    },
    messageContainer:{
       height:"40%",
       display:"flex",
       flexDirection:"column"
    },
    messageContent:{
        color: "#666666",
        height:55,
        maxWidth:492,
        fontSize:20,
        fontWeight:600,
        lineHeight:"27px",
        textAlign: "center",
        alignSelf:"center",
        '@media (max-width: 480px)': {
            fontSize: 12,
        }
    },
    homeButton:{
        width:150,
        marginTop:"5%",
        alignSelf:"center",
        backgroundColor:"#077566",
        textTransform:"none",
        height:44,
        textDecoration: "none",
        fontWeight:600,
        color: "#FFFFFF",
        fontSize:18
    },
}

const ServerError = props => {
    const { classes } = props;
    return (
        <div className={classes.pageBg}>
            <div className={classes.container}>
            <div className={classes.pageIconContainer}>
                <div className={classes.pageIcon}></div>
            </div>
            <div className={classes.messageContainer}>
                <div className={classes.messageTitle}>Something went wrong</div>
                <Button color="primary" variant="contained" 
                    classes={{root: classes.homeButton}}
                    href={appConstant.NAV_URLS.IBPLANNING_HOME}
                >
                    Reload
                </Button>
            </div>
            </div>
        </div>
    )
}

export default withStyles(styles)(ServerError);
